<template>
	<el-container id="test" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in page_location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon" v-if="!done_exam_result" v-loading="done_exam_load">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
					<p class="time">题数：{{question_info.length}}</p>
				</div>
			</div>
			<el-form :model="testForm">
				<div class="big_question" v-for="(item,key,index) in formal" :key="index">
					<div class="big_qs_tit">
						{{$selfjs.qiZh(index+1)}}、{{item.headline == "" ? big_qs_tit_txt(key) : item.headline}}	<!-- {{big_qs_tit_txt(key)}} -->
						<font>（共{{item.list.length}}题）</font>
					</div>
					<ul :class="key">
						<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.question.title.replace(/\n/g, '<br>').replace(/\ /g, '&nbsp;')"></span></p>
							<p v-if="tiObj.question.question_img_has_one" class="question_img"><img @click="handlePictureCardPreview(ali_oss+tiObj.question.question_img_has_one)" :src="ali_oss+tiObj.question.question_img_has_one"></p>
							<dl v-if="key=='single'">
								<el-form-item v-for="(chObj,ch_index) in tiObj.question.choices" :key="ch_index">
									<el-radio-group @input="answer_arr_input" v-model="tiObj.answer_arr[0]">
										<el-radio :label="chObj.flag" :disabled="tiObj.analysis">
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview(ali_oss+chObj.img)" :src="ali_oss+chObj.img">
											 {{chObj.content}}
										</el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
							<dl v-if="key=='multiple'">
								<el-form-item>
									<el-checkbox-group @input="answer_arr_input"  v-model="tiObj.answer_arr">
										<el-checkbox :disabled="tiObj.analysis" v-for="(chObj,ch_index) in tiObj.question.choices" :key="ch_index" :label="chObj.flag" :name="key+ti_index+ch_index">
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview(ali_oss+chObj.img)" :src="ali_oss+chObj.img">
											{{chObj.content}}
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</dl>
							<dl v-if="key=='judgement'">
								<el-form-item>
									<el-radio-group @input="answer_arr_input"  v-model="tiObj.answer_arr[0]">
										<el-radio :disabled="tiObj.analysis" label="对"></el-radio>
										<el-radio :disabled="tiObj.analysis" label="错"></el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
							<el-button :type="tiObj.analysis?'info':'primary'" size="mini" @click="analysis_click(tiObj)">检查答案看解析</el-button>
							<div class="analysis" v-if="tiObj.analysis">
								<div class="prompt" :class="tiObj.analysis_bol?'':'error'">
									<i class="iconfont">{{tiObj.analysis_bol?'&#xe68b;':'&#xe613;'}}</i>
									您<span class="primary_answer">{{tiObj.analysis_bol?'答对':'答错'}}</span>了
								</div>
								<div class="daan"><span class="zhengque">正确答案</span>{{tiObj.question.answer.expect}}</div>
								<div class="daan" v-if="tiObj.question.analysis"><span class="zhengque">答案解析</span><span  v-html="tiObj.analysis.replace(/\n/g, '<br>').replace(/\ /g, '&nbsp;')"></span></div>
								<div v-if="tiObj.analyses.length" class="analyses_video">
									<div v-for="(analys_item,analys_i) in tiObj.analyses" :key="analys_i">
										<!-- :poster="analys_item.video.poster" -->
										<video v-if="analys_item.video" style="width: 80%; margin: 30px 0;" controls>
    									    <source
    									        :src="analys_item.video.url"
    									        type="video/mp4">
    									    您的浏览器不支持视频标签。
    									</video>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<!-- <el-button type="primary" class="submitForm" @click="submitForm('testForm')"><i class="iconfont">&#xe651;</i>提交</el-button> -->
			</el-form>
		</div>
		<div v-if="done_exam_result" class="exerciseCon">
			<div class="title_box">
				{{test_tit}}
				<span>
					<i class="iconfont">&#xe6ea;</i>
					题数：{{test_exam}}
				</span>
			</div>
			<div class="result_con">
				<h3 class="deliver">交卷时间：{{done_exam.time}}</h3>
				<div class="progress_box">
					<el-progress :stroke-width='10' :show-text="false" :width="150" type="circle" :percentage="done_exam.percentage" :color="colors"></el-progress>
					<div class="score">
						<h1>{{done_exam.sys_score}}<font>分</font></h1>
						<span>计分题{{test_exam}}道</span>
					</div>
				</div>
				<div class="res_info">
					共{{test_exam}}题，答对{{done_exam.right_num}}道，答错{{done_exam.wrong_num}}道<br>
					总用时{{done_exam.total_time}}
				</div>
			</div>
			<div class="btn_box">
				<div class="error_btn" @click="test_err('error')"><i class="iconfont">&#xe61a;</i>错题解析</div>
				<div class="all_btn" @click="test_err('all')"><i class="iconfont">&#xe61a;</i>全部解析</div>
				<div class="again_btn" @click="test_again"><i class="iconfont">&#xe7db;</i>再测一次</div>
			</div>
		</div>
        <div v-if="!done_exam_result" class="timeCalculationBox">
			<div class="timeCalculationBoxHed">
				<p class="hed_txt">答题卡</p>
				<p class="hed_tip">点击图标跳到对应题目</p>
			</div>
			<!-- <div class="timeBox" v-if="test_time"><i class="iconfont">&#xe6b1;</i>{{timeCal}}</div> -->
			<div class="timu_scroll">
				<ul>
					<li v-for="(item,key,index) in formal" :key="index">
						<!-- <h2>{{big_qs_tit_txt( key )}}</h2> -->
						<h2>{{item.headline == "" ? big_qs_tit_txt(key) : item.headline}}</h2>
						<dl>
							<dd v-for="(obj,numindex) in item.list" :class="submitted_bol?sub_time_cal_class(obj):time_cal_class(obj)" :key="numindex" @click="scrollFn(key+index+numindex)">
                                {{numindex+1}}
                            </dd>
						</dl>
					</li>
				</ul>
			</div>
			<el-button type="primary" size="mini" v-if="!submitted_bol" class="sizeSubmitForm" @click="submitForm()">提交练习</el-button>
			<el-button type="primary" size="mini" v-else class="sizeSubmitForm" @click="location_reload()">再测一次</el-button>
		</div>
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="30%">
			<span>当前正在考试，是否离开</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="pageout">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
	</el-container>
</template>

<script>
// import { log } from 'util';
var tnum
let token, serverSrc, qianzui, question_info
const OSS = require('ali-oss');
// let client = new OSS({
// 	secure:true,
// 	region: 'oss-cn-shenzhen',
// 	accessKeyId: 'LTAI5t9WQNcsH2e7W5Nr78HL',
// 	accessKeySecret: '4FIy6qj1dSDhGy521AxKKkpdcssUYm',
// 	bucket: 'study-ol-oss',
// });
export default {
	inject: ['reload'],		//注入reload方法
	name: 'test'
	,data () {
		tnum=0;
		let formal={
			single:{	 //单选题
				list: [],
			},
			multiple:{		//多选题
				list:[],
			},
			judgement:{		//判断题
				list:[],
			},
		}

		return {
			// client:new OSS(this.global.new_oss),
			time_cal_show:false,
			// 交卷防止多次
			done_exam_load:false,
			//拍摄
			join_kaoshi:this.global.join_kaoshi,	//是否渲染拍摄
			imgSrc: '',
        	thisCancas: null,
        	thisContext: null,
        	thisVideo: null,
			camera:true,
			//拍照计时
			photo_time:0,

			// 页面参数
			ali_oss:this.global.oss_link,
			test_load:true,
			page_location:[],
			location:[{
				title:"首页",
				router:"/web/index/",
				name: 'index',
			},{
				title:"我的课程",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{courseId:this.$route.query.courseId}
			},{
				title:"题库练习",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{
					courseId:this.$route.query.courseId,
					menuBox:'tiku',
				}
			}],
			//文件上传
			question_preview_visible:false,
			preview_img_src:'',
			upload_img_info:{
				key:'',
				ti_index:'',
			},

			//试题
			test_tit:'',
			test_time:0,
			test_fen:0,
			test_exam:0,
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
				other1:[],
				other2:[],
				universal:[]
			},
			testForm_universal:[],
			formal:formal,
			timeCal:"0:00:00",
			//结果
			done_exam_result:false,
			done_exam:{
				time:'2021年8月18日 15：30',
				sys_score:0,
				percentage:0,
				right_num:0,
				wrong_num:0,
				total_time:'1小时5分28秒',
			},
			colors: [
				{color: '#f56c6c', percentage: 20},
				{color: '#e6a23c', percentage: 40},
				{color: '#5cb87a', percentage: 60},
				{color: '#1989fa', percentage: 80},
				{color: '#5777fe', percentage: 100}
			],

			//页面离开
			tijiaolikai:false,
			dialogVisible:false,
			beforeRouteLeave_next:'',
			leave_type:'',
			//大题排序
			universal_sort:0,
			universal_sort_arr:[],
            question_info:[],
			//是否已提交
			submitted_bol:false,
			//答对数量
			correct_number:0
		}
	}
	,mounted:function(){
		var that=this
		token=this.$cookies.get("token")
		serverSrc=that.global.serverSrc
		qianzui=that.global.qianzui
		question_info

		this.page_location = this.location
		//判断是否从考试安排页进入
		// if(!this.join_kaoshi.switch){
		// 	this.$alert('请从考试安排进入考试页', '提示', {
		// 		confirmButtonText: '确定',
		// 		closeOnHashChange: false,
		// 		showClose: false,
		// 		callback: action => {
		// 			this.back_courseInfo()
		// 		}
		// 	});
		// 	return false;
		// }
		
		//修改上一页的网址
		history.pushState(null, null, document.URL);
    	window.addEventListener('popstate', function () {
			if(!that.dialogVisible){
				//修改切换页面的类型
				that.leave_type = 'popstate'
				//显示询问返回的弹窗
				that.dialogVisible = true
				//修改上一页的网址
				history.pushState(null, null, document.URL);
			}
    	});
		//获取试题信息
		let url = serverSrc + qianzui
			,get_data = {}

		url += "/questions/questionBankList"
		get_data = {
			courseId: this.$route.query.courseId,
			quantity: this.$route.query.quantity
		}
		this.test_tit = this.$route.query.test_tit
		// 获取试题
		this.$ajax.get(url,{
			params: get_data
		})
		.then(function(res){
			let resData=res.data
			if(resData.code==0){
                let tabs={
  	    		  	single: '单选题',
  	    		  	multiple: '多选题',
  	    		  	judgement: '判断题',
  	    		}
				question_info = resData.data
                that.question_info = question_info
				//document.title = question_info.title + '题库练习' + that.global.titleAfter			//动态设置标题

				that.done_start_time = new Date().getTime()		//练习开始时间
				that.test_load = false
				// that.formal = question_info.question
                for (let i = 0; i < question_info.length; i++) {
                    question_info[i].question.id = question_info[i].id
					question_info[i].answer_arr = []
					that.formal[question_info[i].question.type].list.push(
						question_info[i]
					)
					that.formal[question_info[i].question.type].headline = tabs[question_info[i].question.type]
                }
				// for (const key in question_info.question) {
				// 	that.formal[key] = question_info.question[key]
				// }
				for (const key in that.formal) {
					if (that.formal[key].list.length==0) {
						delete that.formal[key]
					}
				}
				// console.log(that.formal);
				// for(var key in question_info.question){
				// 	// console.log(that.testForm);
				// 	let tiNnum=question_info.question[key].list.length,
				// 		tiArr=[]
				// 	for(let t=0;t<tiNnum;t++){
				// 		let tiId = question_info.question[key].list[t].id,
				// 			tianArr = []
				// 		if(key == "fill" || key == "other1" || key == "other2"){
				// 			for(let f=0;f<question_info.question[key].list[t].fill_count;f++){
				// 				tianArr.push("")
				// 			}
				// 		}
				// 		tiArr.push({"question_id":tiId, "answer":tianArr, "answer_img":[]})
				// 	}
				// 	that.testForm[key] = tiArr
				// }
				console.log(that.formal);
				// console.log(that.testForm);
				// console.log(that.testForm_universal);
				let cal=$(".timeCalculationBox"),
					calTop=cal.offset().top,
					calLeft=cal.offset().left
				$(window).scroll(function(){
					if($(document).scrollTop() > 0){
						cal.addClass("pfx").css({
							top:calTop,
							left:calLeft-3
						})
					}else{
						cal.removeClass("pfx").removeAttr("style");
					}
				})
				
			}else{
				that.$alert(resData.message, '提示', {
					confirmButtonText: '确定',
					closeOnHashChange: false,
					showClose: false,
					callback: action => {
						that.tijiaolikai=true
						that.back_courseInfo()
					}
				});
			}
		})
	}
	,methods:{
		handProgress(key, ti_index){
			// console.log('点击添加文件');
			this.upload_img_info = {
				key:key,
				ti_index:ti_index
			}
		},
		handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							// console.log(res);
							if (res.ok) {
								that.testForm[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
			}
		},
		u_handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							// console.log(res);
							if (res.ok) {
								that.testForm_universal[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
				
				
			}
		},
		handle_exceed(files, fileList){
			// console.log('文件超出个数限制时的钩子');
			this.$alert('最多上传5张图片', '信息提示', {
				confirmButtonText: '确定'
			})
		},
		handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm[key][ti_index].answer_img
				,that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
					console.log(item);
					// let del_res = that.client.delete(item.name)
					console.log(del_res);
					// .then((res)=>{
					// 	if(res.res && res.res.statusMessage == "OK"){
					// 	}
					// })
					// .catch((err)=>{
					// 	console.log(err);
					// })
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		u_handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm_universal[key][ti_index].answer_img
				,that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
					console.log(item);
					// let del_res = that.client.delete(item.name)
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		handlePictureCardPreview(file) {
			this.question_preview_visible = true
			this.preview_img_src = file
		},
		//返回到考试页
		back_courseInfo(){
			let router_arr = this.page_location[this.page_location.length-1]
			this.$router.push({
				path: router_arr.router,
				name: router_arr.name,
				query: router_arr.query,
				params: ''
			})
		},
		//点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//大标题文字输出
		big_qs_tit_txt(t){
			let c;
			switch (t) {
				case "single":
					c="单选题"
					break;
				case "multiple":
					c="多选题"
					break;
				case "judgement":
					c="判断题"
					break;
				case "fill":
					c="填空题"
					break;
				case "open":
					c="主观题"
					break;
				case "other1":
					c="名词解释题"
					break;
				case "other2":
					c="论述分析题"
					break;
			}
			return c;
		},
		//交卷函数
		done_exercise(){
			this.done_exam_load = true
			let that=this
				,url = serverSrc+qianzui+'/questions/doQuestion'
			
			this.tijiaolikai=true
			let testForm = this.formal;
			let anArr=[]
			for(var key in testForm){
				if (key!='universal') {
					testForm[key].list.forEach(function(item,index){
						// if(item.answer_arr.length != 0){
							anArr.push({
								questionId:item.question_id,
								id:item.id,
								answer:item.answer_arr?item.answer_arr:''
							})
						// }
					})	
				}
			}
			// this.done_end_time = new Date().getTime()		//练习结束时间
			// console.log(anArr);
			// return false
			// let total_time = parseInt( (this.done_end_time - this.done_start_time) / 1000)
			//交卷请求
			this.$ajax.post(url,
				{answerList: anArr,}
				// this.$qs.stringify({
				// 	answerList: anArr,
				// 	// use_time: total_time,
				// 	// exercise_id: this.$route.query.test_id
				// })
			)
			.then(function(res){
				let resData=res.data;
				if(resData.code==0){
					that.submitted_bol_fn()
					that.done_exam_load=false
					that.$alert('提交成功！！！', '信息提示', {
						confirmButtonText: '确定',
						// callback: action => {
						// 	// 页面切换到计算页
						// 	that.done_exam_result = true
						// 	// 交卷时间输出
						// 	let end_at = resData.data.end_at.split(" ")
						// 		,end_day = end_at[0].split("-")
						// 	that.done_exam = resData.data
						// 	that.done_exam.time = end_day[0]+"年"+end_day[1]+"月"+end_day[2]+"日 " + end_at[1]
						// 	that.done_exam.percentage = (resData.data.sys_score / that.test_fen) * 100		// 得分百分比
						// 	that.done_exam.sys_score = resData.data.sys_score								// 得分
						// 	that.done_exam.wrong_num = resData.data.wrong_num + resData.data.not_done_num	// 答错题目数：答错+未做
						// 	that.done_exam.total_time = that.$selfjs.secondsFormat(total_time, {format:"H小时M分S秒"})
						// 	that.$nextTick(function () {
						// 		$(".el-progress-circle__track").attr("stroke","#fff")		//修改百分比圈的底色
						// 	})
						// }
					});
				}else{
					that.$message.error(resData.message);
					that.done_exam_load=false
				}
			})
			.catch(()=>{
				that.$message.error("网络异常");
				that.done_exam_load=false
			})
		},
		//点击提交按钮
		submitForm() {
			// this.$message.error('提交失败');
			// return 
			let that=this
			let ble=true
			// console.log(this.testForm);
			let testForm=this.formal
			for(let key  in testForm){
				if (key!='universal') {
					if(key!='fill'){
						for(let i = 0;i<testForm[key].length;i++){
							if(testForm[key][i].answer_arr.length==0){
								ble=false
								break;
							}
						}
					}else{
						for(let i = 0;i<testForm[key].length;i++){
							for(let j = 0;j<testForm[key][i].answer_arr.length;j++){
								if(testForm[key][i].answer_arr[j]==''){
									ble=false
									break;
								}
							}

						}
					}	
				}
  			    //   console.log(key + '---' + testForm[key])
  			}
			if(ble){
				this.$confirm('是否交卷?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.done_exercise();
				}).catch(() => {
					//点击取消          
				});
			}else{
				this.$confirm('该试题还没完成，是否继续答题?', '温馨提示', {
					confirmButtonText: '完成交卷',
					cancelButtonText: '继续答卷',
					type: 'warning'
				}).then(() => {
					that.done_exercise(); 
				}).catch(() => {
					//点击取消         
					
				});
			}
			
		},
		//页面滚动
		scrollFn(cla){
			$("html,body").animate({
				scrollTop:$('.'+cla).offset().top-100
			})
		},
		//悬浮框高亮样式
		time_cal_class(obj){
			// return ''
			let cla=''
			if(obj.answer_arr){
				for(var a=0;a<obj.answer_arr.length;a++){
					if(obj.answer_arr[a].length>0){
						cla = 'act'
						break;
					}
				}
			}
			return cla
		},
		//提交之后悬浮窗样式
		sub_time_cal_class(obj){
			let cla='red'
			if(obj.answer_arr&&obj.answer_arr==obj.question.answer.expect){
				cla='green'
			}
			return cla
		},
		//再测一次
		test_again(){
			this.reload()
		},
		//题目解析
		test_err(type){
			let data = this.$route.query
			data.log_id = this.done_exam.id
			data.result = 0

			if(type == 'error'){
				data.result = '0,2'
			}else if(type == 'all'){
				data.result = ''
			}
			// 跳转到题目解析页
			this.$router.push({
				path: '/web/courseInfo/exercise_err',
				name: 'exercise_err',
				query: data,
				params: ''
			})
		},
		//离开页面函数
		pageout(){
			if(this.leave_type == 'beforeRouteLeave'){
				//执行默认的跳转操作
				this.beforeRouteLeave_next()
			}else if(this.leave_type == 'popstate'){
				this.$message({
					showClose: true,
					message: '再次点击确定将执行返回上一页',
					type: 'warning'
				});
				this.dialogVisible = false
				//点击上一页按钮则返回考试安排列表页
				this.back_courseInfo()
			}
		},
		//点击解析
		analysis_click(obj){
			if (!obj.analysis) {
				obj.analysis = true
				obj.analysis_bol = obj.answer_arr==obj.question.answer.expect
				this.$forceUpdate();	
			}
		},
		//点击提交
		submitted_bol_fn(){
			let sum = 0
			for (const key in this.formal) {
				for (let i = 0; i < this.formal[key].list.length; i++) {
					let obj = this.formal[key].list[i]
					obj.analysis_bol = obj.answer_arr==obj.question.answer.expect
					obj.analysis = true
					if (obj.analysis_bol) {
						sum++
					}
				}
			}
			// console.log(sum);
			this.correct_number = sum
			this.submitted_bol = true
			this.$forceUpdate();
			this.submitForm()
			// console.log(this.formal);

		},
		//刷新页面
		location_reload(){
			for (const key in this.formal) {
				for (let i = 0; i < this.formal[key].list.length; i++) {
					let obj = this.formal[key].list[i]
					obj.answer_arr = []
					obj.analysis = false
				}
			}
			this.correct_number = 0
			this.submitted_bol = false
			this.$forceUpdate();
			// window.location.reload()
		},
		answer_arr_input(){
			this.$forceUpdate();	
		}
	},
	computed:{
	},
	destroyed:function(){
		clearTimeout(this.global.pageTimer['examTime'])
	},
	//vue切换页面
	beforeRouteLeave(to, form, next){
		if(this.join_kaoshi.switch && !this.tijiaolikai){
			if(!this.dialogVisible){
				this.leave_type = 'beforeRouteLeave'
				this.dialogVisible = true
				history.pushState(null, null, `/web/#/web/courseInfo?courseId=${this.$route.query.courseId}&menuBox=zuoye`);

				this.beforeRouteLeave_next = next	
			}
		}else{
			next();
			// clearTimeout(this.global.pageTimer['examTime'])
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style lang="scss" scoped>
#index{background:#f4f4f4;}
.title{
	display: inline-block;
	max-width: calc(100% - 100px);
    // width: calc(100% - 100px);
    word-wrap: break-word;
}
.zhengque{
	margin-top: 5px;
    margin-right: 10px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #009688;
    color: #fff;
}
.daan{
    font-size: 16px;
	word-wrap:break-word;
}
.analysis{
	margin-top: 20px;
	padding: 15px 20px;
	background-color: #f2f2f2;
}
.prompt{
	font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 10px;

}
.prompt .iconfont{
	font-weight: 400;
    font-size: 25px;
    color: #009688;
    margin-right: 10px;
    position: relative;
    top: 2px;
}
.primary_answer{
	color: #009688;
    margin: 0 5px;
}
.error .iconfont,.error .primary_answer{
	color: red;
}
.timeCalculationBoxHed{
	margin: 20px 14px;
	padding-bottom: 20px;
	border-bottom: 1px solid #ddd;
}
.hed_txt{font-size: 15px;}
.hed_tip{color: #999999;}
.sizeSubmitForm{
	margin: 10px 0;
    margin-left: 50%;
    transform: translateX(-50%);
}
.rightBox#test .timeCalculationBox ul li dd.green{background-color: #009688;color: #fff;}
.rightBox#test .timeCalculationBox ul li dd.red{background-color: red;color: #fff;}
</style>
<style>
	#test .el-form-item__content .el-textarea__inner{
		resize: vertical;
	}
</style>


// WEBPACK FOOTER //
// src/components/course_info/wrong_question_book.vue